import { useEffect, useState } from "react";

// Detects when a newer published build is available so we can prompt a refresh.
// Mechanism: CRA rewrites /asset-manifest.json (hashed bundle names) on every
// production build. We capture the running build's manifest signature on load,
// then poll periodically; if the signature changes, a new version is live.
// No-ops gracefully in dev (dev server has no asset-manifest.json).
const POLL_MS = 5 * 60 * 1000; // 5 minutes

async function fetchSignature() {
  try {
    const res = await fetch(`/asset-manifest.json?t=${Date.now()}`, { cache: "no-store" });
    if (!res.ok) return null;
    const data = await res.json();
    const files = data.files || data;
    return files["main.js"] || JSON.stringify(files);
  } catch {
    return null;
  }
}

export default function useVersionCheck() {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    let baseline = null;
    let timer = null;
    let cancelled = false;

    (async () => {
      baseline = await fetchSignature();
      if (!baseline || cancelled) return; // dev / unavailable -> disable checks
      timer = setInterval(async () => {
        const current = await fetchSignature();
        if (current && current !== baseline) setUpdateAvailable(true);
      }, POLL_MS);
    })();

    return () => {
      cancelled = true;
      if (timer) clearInterval(timer);
    };
  }, []);

  return updateAvailable;
}
